
import Vue from "vue";
import axios from "axios";
import { Extension, Queue } from "@/types/conf";
import { ExtenStatus } from "@/types/enums";
import { mapActions, mapGetters } from "vuex";
import * as action from '@/store/actions';
export default Vue.extend({
  name: "RamaisList",
  data: () => ({
    queueId: null,
    dialog: false,
    expanded: [] as any[],
    search: "",
    searchQueues: "",
    selectedItem: null,
    queues: [] as Queue[],
    computedItems: screen.width < 600 ? 1 : 5,

    currentPage: 0,
    itemsPerPage: 20,
    resultCount: 0,
  }),
  mounted() {
    this.refreshList();
  },
  computed: {
    ...mapActions({
      getList: 'crudService/getList',
    }),
    ...mapGetters({
      menuIconColor: "lookAndFeel/menuIconColor",
      menuFontColor: "lookAndFeel/menuFontColor",
      extenList: "panel/extenList",
      queueList: "panel/queueList",
      callTimes: "panel/callTimes",
    }),
  },

  methods: {
    ...mapActions({
      deleteItem: "panel/deleteQueueMember",
      addToQueue: "panel/addQueueMember",
    }),
    async refreshList() {
      const token = localStorage.getItem('token');
      const response = await axios.get(action.QUEUE_CONTROLLER, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      this.queues = response.data;
    },
    formatAction(action: string) {
      if (!action) return "";
      if (action.startsWith("que")) {
        return this.formatQueueAction(action);
      }
      return this.$t(`actions.${action}`);
    },
    formatQueueAction(action: string) {
      const match = action.match(/_(\d+)$/);
      if (!match) return this.$t("misc.unknownQueue");

      const queueId = parseInt(match[1]);
      const queue = this.queues.find(q => q.id === queueId);

      return queue ? queue.name : "";
    },
    extenHeaders() {
      return [
        {
          text: "",
          align: "start",
          sortable: false,
          width: 20,
        },
        {
          text: "Nº",
          value: "number",
        },
        {
          text: this.$i18n.t("loginView.userName"),
          value: "userName",
        },
        {
          text: this.$i18n.t("misc.action"),
          value: "action",
        },
        {
          text: this.$i18n.t("misc.occupied"),
          value: "onbusy",
        },
        {
          text: this.$i18n.t("misc.enabled"),
          value: "enabled",
        },
      ];
    },

    color(item: Queue | Extension | any) {
      switch (item.status) {
        case 0:
          return "#abababaa"; // Disconnected
        case 1:
          return "light-blue lighten-2"; // In use
        case 2:
          return "deep-purple lighten-1"; // Ringing
        case 3:
          return "green accent-4"; // Connected
        case 4:
          return "red darken-2"; // Hang up
        case 5:
          return "amber darken-1"; // Music on Hold
        default:
          return "#abababaa";
      }
    },
    icon(item: Queue | Extension | any) {
      switch (item.status) {
        case ExtenStatus.Online:
          return "mdi-check"; // Connected
        case ExtenStatus.Offline:
          return "mdi-close"; // Disconnected
        case ExtenStatus.MOH:
          return "mdi-audio"; // Music on Hold
        default:
          return "mdi-phone";
      }
    },
  },


});
